import {
  READING_TYPE, COUTER,
  RECEIVE_BOOK_ID,
  RECEIVE_CURRENT_PAGE,
  RECEIVE_DETAIL_INFO,
  RECEIVE_USER_INFO, RECEIVE_FILTER_QUERY,
  RECEIVE_SEARCH_RESULT, RECEIVE_NAV_AREA, RECEIVE_NAV_INDEX, RECEIVE_SEARCH_NAME,
  RECEIVE_INDEX_NAV, RECEIVE_FILTER_LIST} from './mutation-types'

export default {
  [RECEIVE_SEARCH_RESULT] (state, {queryList}) {
    state.searchresult = queryList
  },
  [RECEIVE_NAV_AREA] (state, {NavAreaCategorys}) {
    state.NavAreaCategorys = NavAreaCategorys
  },
  [RECEIVE_NAV_INDEX] (state, {indexNavList}) {
    state.IndexTopicCatagorys = indexNavList
  },
  [RECEIVE_SEARCH_NAME] (state, {queryInfo}) {
    // localStorage.setItem(`queryInfo`, JSON.stringify(queryInfo))
    state.queryInfo = queryInfo
  },
  [RECEIVE_INDEX_NAV] (state, {indexNavList}) {
    state.indexNavList = indexNavList
  },
  [RECEIVE_FILTER_LIST] (state, {list}) {
    localStorage.setItem(`filterShowList`, JSON.stringify(list))
    state.filterShowList = list
  },
  [RECEIVE_FILTER_QUERY] (state, {list}) {
    localStorage.setItem(`filterQueryist`, JSON.stringify(list))
    state.filterQueryist = list
  },
  [RECEIVE_USER_INFO] (state, {userinfo}) {
    localStorage.setItem(`userinfo`, JSON.stringify(userinfo))
    state.userinfo = userinfo
  },
  [RECEIVE_DETAIL_INFO] (state, {itemInfoArr}) {
    state.detailInfoArr = itemInfoArr
  },
  [RECEIVE_CURRENT_PAGE] (state, {curentPagePostion}) {
    // localStorage.setItem(`currentPage`, JSON.stringify(curentPagePostion))
    state.currentPage = curentPagePostion
  },
  [RECEIVE_BOOK_ID] (state, {bookId}) {
    localStorage.setItem(`bookId`, JSON.stringify(bookId))
    state.book_id = bookId
  },
  [COUTER] (state, {updataCouter}) {
    localStorage.setItem(`count`, JSON.stringify(updataCouter))
    state.upCouter = updataCouter
  },
  [READING_TYPE] (state, {itemType}) {
    localStorage.setItem(`itemType`, JSON.stringify(itemType))
    state.readingType = itemType
  }
}



// WEBPACK FOOTER //
// ./src/store/mutations.js